/**
 *
 * Asynchronously loads the component for OverviewPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const OverviewPage = lazyLoad(
  () => import('./index'),
  module => module.OverviewPage,
);
